import { VHeaders } from '@/models/pagedlistmodel';

export function getVehicleReviveListHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveCenter.reviveCenterGridHeaders.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveCenter.reviveCenterGridHeaders.type'
      ) as string,
      value: 'type',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'vehicleReviveCenter.reviveCenterGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
